import { IRoute } from '@app/Router/IRoute'

import { getPostponedLetterRequestsPath } from './paths'
import { PostponedLetterRequestsPage } from './PostponedLetterRequests/PostponedLetterRequestsPage'

export const routes: IRoute[] = [
  {
    path: getPostponedLetterRequestsPath(),
    component: PostponedLetterRequestsPage,
    exact: true
  }
]
